import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useVantifyServiceProviderCustomPrioritiesEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.VantifyServiceProviderCustomPriorities, false);

  return Boolean(isEnabled);
}
